<template>
  <div>
    <h2>Make Call List</h2>

    <!-- Show loading indicator -->
    <div v-if="loading">Loading...</div>

    <!-- Show error message if error occurs -->
    <div v-if="error" class="error-message">
      Error fetching data: {{ error.message }}
    </div>

    <!-- Refresh button -->
    <v-btn @click="fetchCalls">Refresh</v-btn>

    <!-- Show list of calls if data is loaded successfully -->
    <div v-if="!loading && !error">
      <div class="call-form">
        <template v-for="(call, index) in calls" :key="call.id">
          <div class="form-row">
            <div class="form-column">
              <label>User:</label>
              <span>{{ call.attributes.user }}</span>
            </div>
            <div class="form-column">
              <label>No.:</label>
              <span>{{ call.attributes.no }}</span>
            </div>
          </div>
          <div class="form-row">
            <div class="form-column">
              <label>Name:</label>
              <span>{{ call.attributes.name }}</span>
            </div>
            <div class="form-column">
              <label>Phone Number:</label>
              <span>{{ call.attributes.phoneNumber }}</span>
            </div>
            <div class="form-column">
              <label>Status:</label>
              <span>{{ call.attributes.status }}</span>
            </div>
          </div>

          <div class="form-row">
            <div class="form-column">
              <label>Last Call:</label>
              <span>{{ formatDate(call.attributes.nextCall) }}</span>
            </div>
            <div class="form-column">
              <label>Next Call:</label>
              <span>{{ formatDate(call.attributes.nextCall) }}</span>
            </div>
          </div>
          <h3>{{ call.attributes.interaction }}</h3>
          <hr v-if="index < calls.length - 1">


        </template>


        <!-- Display a message if no records are fetched -->
        <div v-if="calls.length === 0">
          No records found.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns'; // Ensure this import is at the top
import { defineComponent, ref } from 'vue';
import { gql } from '@apollo/client/core';
import client from '../apollo-client'; // Ensure Apollo client is correctly imported


const GET_MAKE_CALLS = gql`
  query GetMakeCalls {
  makeCalls(sort: ["updatedAt:desc"]) {
    data {
      id
      attributes {
        name
        status
        interaction
        no
        user
        phoneNumber
        lastCall
        nextCall
        updatedAt
      }
    }
  }
}
  `;

export default defineComponent({
  name: 'MakeCallList',
  setup() {
    const calls = ref([]);
    const loading = ref(false);
    const error = ref(null);

    const fetchCalls = async () => {
      try {
        loading.value = true;
        const { data } = await client.query({
          query: GET_MAKE_CALLS,
          fetchPolicy: 'no-cache' // Bypass the cache
        });
        calls.value = data.makeCalls.data.filter(call => call.id !== "4");
        loading.value = false;
      } catch (err) {
        console.error('Error fetching make calls:', err);
        error.value = err;
        loading.value = false;
      }
    };

    // Fetch data on component mount
    fetchCalls();

    return {
      fetchCalls,
      loading,
      error,
      calls,
    };
  },
  
  

 
    methods: {
      formatDate(dateString) {
        if (!dateString) return ''; // Return an empty string if dateString is undefined or null
        const date = new Date(dateString);
        return format(date, 'dd/MM/yy HH:mm');
      }
    }
  
});
</script>

<style scoped>
.error-message {
  color: red;
  margin-top: 10px;
}

.call-form {
  margin-bottom: 20px;
}

.form-row {
  display: flex;
  margin-bottom: 10px;
}

.form-column {
  flex: 1;
  margin-right: 20px;
}

label {
  font-weight: bold;
  margin-right: 5px;
  min-width: 100px;
  /* Ensure labels are aligned */
  display: inline-block;
}

span {
  display: inline-block;
  min-width: 200px;
  /* Ensure values are aligned */
}

hr {
  border-top: 1px solid #ccc;
  margin-top: 20px;
}
</style>